import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentMethod } from '../../../../../../../../../core/enums/commerce/payment/payment-method';
import { nameOf } from '../../../../../../../../../core/functions/string-helpers';
import { FormGroupType } from '../../../../../../../../../core/models/form-group-type';
import { RegExPattern } from '../../../../../../../../../core/models/regexp-pattern/regex-pattern';
import { PaymentValidationMessages } from '../../../../../../shared/constants/payment-validation-messages';
import { maxAmountValidator } from '../../../../../../shared/validators/order-payment-validators';
import { PaymentTransactionConstants } from '../../../../../constants/payment-transaction-constants';
import { ConfirmPaymentFormModel } from '../models/confirm-payment-form-model';

@Injectable({
    providedIn: 'root',
})
export class ConfirmPaymentFormService {
    getFormDefinition(
        balanceRemaining: number,
    ): FormGroup<FormGroupType<ConfirmPaymentFormModel>> {
        return new FormGroup<FormGroupType<ConfirmPaymentFormModel>>({
            paymentMethod: new FormControl<PaymentMethod | null>(null, [
                Validators.required,
            ]),
            amount: new FormControl<number | null>(balanceRemaining, [
                Validators.required,
                Validators.min(PaymentTransactionConstants.MIN_PAYMENT_AMOUNT),
                maxAmountValidator(balanceRemaining, {
                    label: nameOf<typeof PaymentValidationMessages>(
                        'amountExceedsBalance',
                    ),
                    message: PaymentValidationMessages.amountExceedsBalance,
                }),
            ]),
            description: new FormControl<string | null>(null, [
                Validators.required,
                Validators.pattern(
                    RegExPattern.PrintableAsciiExceptAngleBracketsAndPipes,
                ),
            ]),
        });
    }
}
